import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import ImageCard from '@blade-sxp/monitoring-center/pages/snap/components/imageCard.vue';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
export default /*#__PURE__*/ _defineComponent({
    __name: 'block-list',
    props: {
        imgList: null
    },
    emits: ['handleClick'],
    setup(__props, { emit }) {
        const props = __props;
        const vm = getCurrentInstance();
        const router = vm?.proxy?.$router;
        const store = useMonitoringStore();
        const handleClick = (portraitImage) => {
            emit('handleClick', portraitImage);
        };
        const goPage = () => {
            const deviceIdList = store.selectedDevices;
            router.push({
                path: '/search/searchPage',
                query: {
                    param: JSON.stringify({ deviceIdList }),
                    type: 'monitor',
                },
            });
        };
        return { __sfc: true, vm, router, store, props, emit, handleClick, goPage, ImageCard };
    }
});
